/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsEodMachineDetail
 */
export interface EodMelcoEodModelsEodMachineDetail {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodMachineDetail
     */
    machine_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodMachineDetail
     */
    device_id?: string | null;
}

export function EodMelcoEodModelsEodMachineDetailFromJSON(json: any): EodMelcoEodModelsEodMachineDetail {
    return EodMelcoEodModelsEodMachineDetailFromJSONTyped(json, false);
}

export function EodMelcoEodModelsEodMachineDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsEodMachineDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'machine_name': !exists(json, 'machine_name') ? undefined : json['machine_name'],
        'device_id': !exists(json, 'device_id') ? undefined : json['device_id'],
    };
}

export function EodMelcoEodModelsEodMachineDetailToJSON(value?: EodMelcoEodModelsEodMachineDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'machine_name': value.machine_name,
        'device_id': value.device_id,
    };
}


